export const btnList = (lang) => {
  return [
    {
      icon: ['fas', 'microphone-slash'],
      label: lang.mute,
      actIcon: ['fas', 'microphone'],
      actLabel: lang.unmute,
      key: "mute"
    },
    {
      // icon: ['fas', 'pause'],
      icon: ['fa-solid', 'fa-circle-pause'],
      label: lang.hold_call,
      actIcon: ['fas', 'play-circle'],
      actLabel: lang.resume_call,
      key: "hold"
    },
    {
      icon: ['fas', 'phone-volume'],
      label: lang.attended_transfer,
      key: "transfer"
    },
    // {
    //   icon: ['fas', 'plus'],
    //   label: lang.conference_call,
    //   actLabel: lang.cancel_conference,
    //   key: "addCall"
    // },
    {
      icon: 'conference',
      label: '三者通話',
      key: "addCall",
      disabled: true,
    },
    // {
    //   icon: ['fas', 'volume-high'],
    //   label: lang.device_settings,
    //   key: "speaker",
    //   disabled: true,
    // },
    // {
    //   icon: ['fas', 'video'],
    //   label: lang.camera,
    //   key: "video",
    //   disabled: true,
    // },
    // {
    //   icon: '',
    //   label: '',
    //   key: "video",
    //   disabled: true,
    // },
    {
      icon: ['fa-solid', 'fa-gear'],
      label: "設定",
      key: "setting"
    },
    // {
    //   icon: ['fas', 'keyboard'],
    //   label: lang.send_dtmf,
    //   key: "keyboard"
    // },
    // {
    //   icon: ['fas', 'plus'],
    //   label: lang.conference_call,
    //   // actLabel: lang.cancel_conference,
    //   key: "addCall"
    // },
      {
      icon: 'keyboard',
      label: lang.send_dtmf,
      key: "keyboard"
    },
    {
      icon: ['fas', 'phone'],
      label: '通話開始',
      key: "startCall",
      disabled:true,
    },
    {
      icon: ['fas', 'phone'],
      label: "切電",
      key: "cancel",
    }
  ]
}